export default __webpack_public_path__ + "static/media/ativarCartao.50cecf9d.svg";